class ProjectsList {
    constructor({
        _id = "",
        image = [],
        artist = "",
        design = "",
        brand = "",
        name="",
        email="",
        created_at=0,
        totalDuration=0,
        diamond_type="",
        no_of_color=0,
        abs=0,
        glow=0,
        crystal=0,
        dreamerDust=0,
        total_amount_diamonds=0,
        timer_status="",
        canvas_height=0,
        canvas_width=0,
        project_status="",
        price=0,
        currency_code="",
        country_code="",
        startDate="",
        endDate="",
        extraNotes="",
        tags=[],
        isAdminVerified=false,
        canvas_start_image="",      
        canvas_complete_image="",
        verification_status="",
        submit_project=false,
        __v = 0
    }) {
        this._id = _id;
        this.image = image;
        this.artist = artist;
        this.design = design;
        this.brand = brand;
        this.name = name;
        this.canvas_height = canvas_height;
        this.canvas_width = canvas_width;
        this.abs = abs;
        this.glow = glow;
        this.crystal = crystal;
        this.dreamerDust= dreamerDust,
        this.total_amount_diamonds = total_amount_diamonds;
        this.diamond_type = diamond_type;
        this.no_of_color = no_of_color;
        this.email = email;
        this.price = price;
        this.currency_code = currency_code;
        this.country_code = country_code;
        this.created_at = created_at;
        this.totalDuration = totalDuration;
        this.timer_status = timer_status;
        this.project_status = project_status;
        this.startDate = startDate;
        this.endDate = endDate;
        this.extraNotes = extraNotes;
        this.tags = tags;
        this.isAdminVerified = isAdminVerified;
        this.__v = __v;
        this.canvas_start_image = canvas_start_image;
        this.canvas_complete_image = canvas_complete_image;
        this.verification_status = verification_status;
        this.submit_project = submit_project;
    }
}

class ProjectModel {
    constructor({
        projects = [],
        totalPages = 0,
        currentPage = 1,
        totalUsers = 0,
        hasNextPage = false
    }) {
        this.projects = projects.map(project => new ProjectsList(project));
        this.totalPages = totalPages;
        this.currentPage = currentPage;
        this.totalUsers = totalUsers;
        this.hasNextPage = hasNextPage;
    }
}

export { ProjectsList, ProjectModel };
